/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserAccountChangeRequest} from '../models/UserAccountChangeRequest';

export interface UserAccountChange$Request {
    userId: number;
    userAccountChangeRequest: UserAccountChangeRequest;
}

export interface UserAccountChange$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const userAccountChangeRequest = createAction<PayloadData<void, UserAccountChange$Request>>('USER_ACCOUNT_CHANGE__USER_ACCOUNT_CHANGE__REQUEST');
export const userAccountChangeSuccess = createAction<PayloadData<void, UserAccountChange$Request>>('USER_ACCOUNT_CHANGE__USER_ACCOUNT_CHANGE__SUCCESS');
export const userAccountChangeFailure = createAction<PayloadData<Error, UserAccountChange$Request, true>>('USER_ACCOUNT_CHANGE__USER_ACCOUNT_CHANGE__FAILURE');

export const userAccountChangeActions = [
    userAccountChangeRequest,
    userAccountChangeSuccess,
    userAccountChangeFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserAccountChangeRequest} meta.userAccountChangeRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const userAccountChange = (meta: UserAccountChange$Request, config?: UserAccountChange$Config) => {
    return {
        CALL_API: {
            types: userAccountChangeActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/change-account`,
            TRANSPORT_REQUEST_BODY: meta.userAccountChangeRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

